import React, { useContext, useEffect, useRef, useState } from 'react';
import { LangContext } from '../contexts/langContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { AUTH_MODAL_SIGNUP, openAuth } from './utilsAuth';


export const PublicSignup = () => {

  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) }
  const $ui = context.$ui;
  let urlParams = new URLSearchParams(window.location.search);
  const signupRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = signupRef.current;
    if (!el || typeof IntersectionObserver === 'undefined') return;
    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { threshold: 0.5 }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  return (
    <div
      className='public_signup0'
    >

        
        <div
          ref={signupRef}
          className={`public_signup${inView ? ' public_signup--in' : ''}`}
        >
          <a
            href='/auth0/login'
            className="x_button x_button--xxl"
            onClick={openAuth(context.setState.setAuthModal, AUTH_MODAL_SIGNUP)}
          >
            <div>
              {urlParams.get('copy') ? $ui('cta_itsme') : $ui('cta_calculate')}
            </div>
            <div className='x_cta_sub'>
              {$ui('cta_itsme_register')}
            </div>
          </a>
        </div>



    </div>
  )
}
